import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function BusinessLayout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

  // Check Auth & Role
  useEffect(() => {
    const fetchProfile = async () => {
        const token = localStorage.getItem('skillmatch_token');
        if (!token) return navigate('/');

        try {
            const res = await fetch(`${API_URL}/api/users/profile`, {
                headers: { 'x-auth-token': token }
            });
            if (res.ok) {
                const data = await res.json();
                setUser(data);
                // Nếu không phải business, đá về trang chủ
                if (data.role !== 'business') navigate('/');
            } else {
                navigate('/');
            }
        } catch (error) {
            console.error("Lỗi tải profile:", error);
            navigate('/');
        }
    };
    fetchProfile();
  }, [navigate, API_URL]);

  return (
    <div className="flex flex-col min-h-screen bg-[#F3F4F6] font-sans text-gray-900">
      
      {/* 1. Header dùng chung Navbar */}
      <Navbar />

      {/* 2. Main Content */}
      <main className="flex-1 w-full max-w-7xl mx-auto pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="animate-fade-in-up">
            <Outlet />
        </div>
      </main>

      {/* 3. Footer dùng chung */}
      <Footer />

      {/* Global Animation */}
      <style>{`
        @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
            animation: fadeInUp 0.4s ease-out forwards;
        }
      `}</style>

    </div>
  );
}